import * as eHubApi from "./data.service";

export function getRecvDashboard(req) {
  const query = [];
  query.push(`dashboardType=${req.dashboardType}`);
  query.push(`customerCode=${req.customerCode}`);
  query.push(`orderType=${req.orderType}`);
  if (req.dateStart) query.push(`dateStart=${req.dateStart}`);
  if (req.dateEnd) query.push(`dateEnd=${req.dateEnd}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/RecvDashboard/get?` + queryString);
}

export function getRecvDashboardStatusCount(req) {
  const query = [];
  query.push(`customerCode=${req.customerCode}`);
  query.push(`orderType=${req.orderType}`);
  if (req.dateStart) query.push(`dateStart=${req.dateStart}`);
  if (req.dateEnd) query.push(`dateEnd=${req.dateEnd}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/RecvDashboard/get-status-count?` + queryString);
}

export function getSalesDashboard(req) {
  const query = [];
  query.push(`dashboardType=${req.dashboardType}`);
  query.push(`customerCode=${req.customerCode}`);
  if (req.filterMethod) query.push(`filterMethod=${req.filterMethod}`);
  if (req.dateStart) query.push(`dateStart=${req.dateStart}`);
  if (req.dateEnd) query.push(`dateEnd=${req.dateEnd}`);
  if (req.dateStart2) query.push(`dateStart2=${req.dateStart2}`);
  if (req.dateEnd2) query.push(`dateEnd2=${req.dateEnd2}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/SalesDashboard/get?` + queryString);
}

export function getSalesDashboardStatusCount(req) {
  const query = [];
  query.push(`customerCode=${req.customerCode}`);
  if (req.filterMethod) query.push(`filterMethod=${req.filterMethod}`);
  if (req.dateStart) query.push(`dateStart=${req.dateStart}`);
  if (req.dateEnd) query.push(`dateEnd=${req.dateEnd}`);
  if (req.dateStart2) query.push(`dateStart2=${req.dateStart2}`);
  if (req.dateEnd2) query.push(`dateEnd2=${req.dateEnd2}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/SalesDashboard/get-status-count?` + queryString);
}

export function getSalesDashboardStatusCountByCustomer(signal,req) {
  const query = [];
  const customers = req.customers.join("&customers=");
  query.push(`customers=` + customers)
  if (req.filterMethod) query.push(`filterMethod=${req.filterMethod}`);
  if (req.dateStart) query.push(`dateStart=${req.dateStart}`);
  if (req.dateEnd) query.push(`dateEnd=${req.dateEnd}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/SalesDashboard/gets?` + queryString, {signal});
}

export function getSalesDashboardStatusCountByCustomer2(signal, req){
  return eHubApi.post(`/api/SalesDashboard/gets2`, req, signal)
}

export function getRecvDashboardStatusCountByCustomer(req) {
  const query = [];
  const customers = req.customers.join("&customers=");
  query.push(`customers=` + customers)
  query.push(`orderType=${req.orderType}`);
  if (req.dateStart) query.push(`dateStart=${req.dateStart}`);
  if (req.dateEnd) query.push(`dateEnd=${req.dateEnd}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/RecvDashboard/gets?` + queryString);
}

export function getRecvDashboardStatusCountByCustomer2(req){
  return eHubApi.post(`/api/RecvDashboard/gets2`, req)
}

export function filterSalesByCustOrdNbr(req){
  const query = [];
  const custOrdNbrs = req.custOrdNbrs.split(',', 10).map(x => x.trim()).join("&custOrdNbrs=");
  query.push(`custOrdNbrs=` + custOrdNbrs)
  const queryString = query.join("&");
  return eHubApi.get(`/api/SalesDashboard/filter-cust-ord-nbr?customerCode=${req.customerCode}&${queryString}`);
}

export function exportNoStock(req){
  const query = [];
  query.push(`customerCode=${req.customerCode}`);
  if (req.filterMethod) query.push(`filterMethod=${req.filterMethod}`);
  if (req.dateStart) query.push(`dateStart=${req.dateStart}`);
  if (req.dateEnd) query.push(`dateEnd=${req.dateEnd}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/SalesDashboard/export-no-stock?${queryString}`,{
    responseType: 'blob',
  });
}

export function exportAllSalesDashboard(req){
  const query = [];
  query.push(`customerCode=${req.customerCode}`);
  if (req.filterMethod) query.push(`filterMethod=${req.filterMethod}`);
  if (req.dateStart) query.push(`dateStart=${req.dateStart}`);
  if (req.dateEnd) query.push(`dateEnd=${req.dateEnd}`);
  if (req.dateStart2) query.push(`dateStart2=${req.dateStart2}`);
  if (req.dateEnd2) query.push(`dateEnd2=${req.dateEnd2}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/SalesDashboard/export-all?${queryString}`,{
    responseType: 'blob',
  });
}